@if (patient) {
    <div class="logged-in-view">
        <!-- Header Section -->
        <div class="space-y-1">
            <h1 class="text-app-primary-10">
                Guten Tag, {{patient.firstName}} {{patient.lastName}}
            </h1>
            <p class="text-app-primary-10/70 text-lg mt-3">
                Willkommen in Ihrem persönlichen Bereich.
            </p>
        </div>

        <!-- Action Section -->
        <div class="w-full my-8">
            <button routerLink="/termine/arztwahl"
                    class="w-full btn primary-button">
                Neuen Termin vereinbaren
            </button>
        </div>

        <!-- Cards Section -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
            <!-- Next Appointment Card -->
            <div class="bg-white rounded-button shadow-sm border border-app-primary-10 p-6 space-y-4 flex flex-col">
                <div class="flex items-center justify-between border-b border-gray-50 pb-4">
                    <div class="text-xl font-bold text-app-primary-10">Nächster Termin</div>
                    <span class="px-3 py-1 bg-app-secondary-10/10 text-app-secondary-10 rounded-full text-sm font-medium">Anstehend</span>
                </div>

                @if (nextAppointment) {
                    <div class="flex-1 space-y-3">
                        <div class="flex items-center gap-3">
                            <div class="w-10 h-10 rounded-full bg-app-primary-10/5 flex items-center justify-center">
                                <i class="fa-regular fa-calendar text-app-primary-10"></i>
                            </div>
                            <div>
                                <p class="text-sm text-gray-500">Datum & Uhrzeit</p>
                                <p class="font-semibold">{{nextAppointment.from | date: 'dd.MM.yyyy, HH:mm'}} Uhr</p>
                            </div>
                        </div>
                        <div class="flex items-center gap-3">
                            <div class="w-10 h-10 rounded-full bg-app-primary-10/5 flex items-center justify-center">
                                <i class="fa-solid fa-user-doctor text-app-primary-10"></i>
                            </div>
                            <div>
                                <p class="text-sm text-gray-500">Arzt</p>
                                <p class="font-semibold">{{nextAppointment.doctor.title ? nextAppointment.doctor.title + ' ' : ''}}{{nextAppointment.doctor.firstName}} {{nextAppointment.doctor.lastName}}</p>
                            </div>
                        </div>
                    </div>
                    <button [routerLink]="['/termine', nextAppointment.id]"
                            class="btn tertiary-button">
                        Zum Termin
                    </button>
                } @else {
                    <div class="flex-1 flex flex-col items-center justify-center py-8 text-center space-y-2">
                        <div class="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-2">
                            <i class="fa-regular fa-calendar-xmark text-gray-300 text-2xl"></i>
                        </div>
                        <p class="text-gray-500 font-medium">Keine anstehenden Termine</p>
                        <p class="text-sm text-gray-400">Buchen Sie Ihren nächsten Termin einfach über den Button oben.</p>
                    </div>
                }
            </div>

            <!-- Latest Recipe Card -->
            <div class="bg-white rounded-button shadow-sm border border-app-primary-10 p-6 space-y-4 flex flex-col">
                <div class="flex items-center justify-between border-b border-gray-50 pb-4">
                    <div class="text-xl font-bold text-app-primary-10">Aktuelles Rezept</div>
                    @if (latestRecipe) {
                        <span class="px-3 py-1 bg-green-50 text-green-600 rounded-full text-sm font-medium">Vorhanden</span>
                    }
                </div>

                @if (latestRecipe) {
                    <div class="flex-1 space-y-3">
                        <div class="flex items-center gap-3">
                            <div class="w-10 h-10 rounded-full bg-app-primary-10/5 flex items-center justify-center">
                                <i class="fa-solid fa-file-prescription text-app-primary-10"></i>
                            </div>
                            <div>
                                <p class="text-sm text-gray-500">Ausgestellt am</p>
                                <p class="font-semibold">{{latestRecipe.issueDate | date: 'dd.MM.yyyy'}}</p>
                            </div>
                        </div>
                        <div class="flex flex-wrap gap-2 pt-2">
                            @for (position of latestRecipe.positions.slice(0, 2); track position) {
                                <span class="px-3 py-1 bg-gray-100 rounded-lg text-sm text-gray-600">
                                    {{position.articleName}}
                                </span>
                            }
                            @if (latestRecipe.positions.length > 2) {
                                <span class="px-3 py-1 bg-gray-50 rounded-lg text-sm text-gray-400">
                                    + {{latestRecipe.positions.length - 2}} weitere
                                </span>
                            }
                        </div>
                    </div>
                    <button routerLink="/patient-rezepte"
                            class="btn tertiary-button">
                        Alle Rezepte ansehen
                    </button>
                } @else {
                    <div class="flex-1 flex flex-col items-center justify-center py-8 text-center space-y-2">
                        <div class="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-2">
                            <i class="fa-solid fa-file-circle-xmark text-gray-300 text-2xl"></i>
                        </div>
                        <p class="text-gray-500 font-medium">Keine aktuellen Rezepte</p>
                        <p class="text-sm text-gray-400">Ihre Rezepte erscheinen hier, sobald sie vom Arzt ausgestellt wurden.</p>
                    </div>
                }
            </div>
        </div>
    </div>
} @else if (isLoading) {
    <div class="flex items-center justify-center h-[60vh]">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary-10"></div>
    </div>
}
